/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { LiveblocksControllerWebhookMutationResponse } from "../../models/liveblocksController/LiveblocksControllerWebhook";

function getLiveblocksControllerWebhookUrl() {
  const res = { method: 'POST', url: `/api/v1/liveblocks/webhook` as const }  
  return res
}

/**
 * @summary Liveblocks webhook receiver for mention notifications
 * {@link /api/v1/liveblocks/webhook}
 */
export async function liveblocksControllerWebhook(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<LiveblocksControllerWebhookMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getLiveblocksControllerWebhookUrl().url.toString(), ... requestConfig })  
  return res.data
}